import { render, staticRenderFns } from "./WatingUsers.vue?vue&type=template&id=2cb357f9&"
import script from "./WatingUsers.vue?vue&type=script&lang=js&"
export * from "./WatingUsers.vue?vue&type=script&lang=js&"
import style0 from "./WatingUsers.vue?vue&type=style&index=0&id=2cb357f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports